import { reactive, computed } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as apiCommon from '@/api/common'
import * as common from '@/util/common'

/**
 * 書式DL一覧画面：書式DL一覧エリアツリー表示
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * 初期表示処理
     */
    init: () => {
    },
    /**
     * オープンフラグ(フォルダの場合のみ有効)
     */
    isOpen: true,
    isFolder: computed(() => {
      const hasChildren = (typeof props.model.children !== 'undefined') && 
              (Array.isArray(props.model.children)) &&
              (props.model.children.length > 0) 
      return (hasChildren || group1.hasFormatList)
    }),
    children: computed(() => {
      return props.model.children
    }),
    /**
     * 書式DLリスト
     */
    formatList: computed(() => {
      const list = props.model.format_list ?? []
      for (let i = 0; i < list.length; i++) {
        const fileId = list[i].file_id
        // 書式のURL
        list[i].url = apiCommon.getFetchFileAPIURL(fileId, true)
      }
      return list
    }),
    hasFormatList: computed(() => {
      const list = props.model.format_list ?? []
      return (list.length > 0)
    }),
    /**
     * フォルダのオープン/クローズの切り替え
     */
    toggle: () => {
      group1.isOpen = !group1.isOpen
    },

    matchedStartNo: computed(() => {
      return props.matchedStartNo
    }),
    matchedEndNo: computed(() => {
      return props.matchedEndNo
    }),
    matchedTotal: computed(() => {
      return props.matchedTotal
    }),
    matchedTotal4Disp: computed(() => {
      return common.breakComma(group1.matchedTotal)
    }),

    /**
     * QAタイトルをクリックした場合
     */
    onClickQATitleOfList: (qaId) => {

      // QA IDを保存
      // 書籍ID、書籍名は、QA詳細画面(QADetail.js)で取得するため、0に設定しておく。
      store.dispatch('qa/setBookId', 0)
      store.dispatch('qa/setBookName', '')
      store.dispatch('qa/setQaId', qaId)
      store.dispatch('qa/setSearchIndexId', 0)
      store.dispatch('qa/setNumberCarouselVisible', 0)

      // QA詳細画面に遷移(URLにQAIDを表示する)
      router.push({ name: 'PCQADetail', params: { qaId: qaId } })
    }

  })

  return group1
}
